import React, { useState } from 'react';
import ScrollToTop from '../components/ScrollToTop';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import TermsOfService from '../components/TermsOfServiceForms';

function TermsPage() {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen);
    };

    return (
        <>
            <ScrollToTop />
            <Sidebar isOpen={isOpen} toggle={toggle} isHeader={true} />
            <Navbar toggle={toggle} isHeader={true} />
            <TermsOfService />
            <Footer />
        </>
    );
}

export default TermsPage;

